export default "__VITE_ASSET__CQPzTfAH__"